import React from 'react';

function StepIndicator({ currentStep, steps }) {
  return (
    <div className="post-job-steps">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isComplete = currentStep > stepNumber;

        return (
          <div
            key={step}
            className={`post-job-step${isActive ? ' active' : ''}${isComplete ? ' complete' : ''}`}
          >
            <div className="post-job-step-circle">{isComplete ? '✓' : stepNumber}</div>
            <span className="post-job-step-label">{step}</span>
          </div>
        );
      })}
    </div>
  );
}

export default StepIndicator;
